import React from 'react';

import {
    RadioContent,
    RadioCustom,
    RadioDescription,
    RadioGroup,
    RadioInput,
    RadioItem,
    RadioLabel,
} from './styled';

interface RadioOption {
    value: string;
    label: string;
    description?: string;
}
interface CustomRadioGroupProps {
    defaultVal?: string;
    options: RadioOption[];
    name?: string;
    type?: 'default' | 'small';
    onChange?: (value: string) => void;
    disabled?: boolean;
    value?: string;
}

export const CustomRadioGroup: React.FC<CustomRadioGroupProps> = ({
    options,
    name = 'radio-group',
    onChange,
    type = 'default',
    disabled,
    value,
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {value} = e.target;

        if (onChange) {
            onChange(value);
        }
    };

    return (
        <RadioGroup>
            {options.map((option) => (
                <RadioItem key={option.value}>
                    <RadioInput
                        disabled={disabled}
                        name={name}
                        value={option.value}
                        checked={value === option.value}
                        onChange={handleChange}
                    />
                    <RadioCustom type={type} disabled={disabled} />
                    <RadioContent>
                        <RadioLabel>{option.label}</RadioLabel>
                        <RadioDescription>{option.description}</RadioDescription>
                    </RadioContent>
                </RadioItem>
            ))}
        </RadioGroup>
    );
};
